import { render, staticRenderFns } from "./myFocus.vue?vue&type=template&id=bc1a278c&scoped=true"
import script from "./myFocus.vue?vue&type=script&lang=js"
export * from "./myFocus.vue?vue&type=script&lang=js"
import style0 from "./myFocus.vue?vue&type=style&index=0&id=bc1a278c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1a278c",
  null
  
)

export default component.exports